import React from "react";
import { Paper, Stack, Typography, useTheme } from "@mui/material";
import { QualityChip } from "./DashboardBits";

interface Props {
  label: string;
  value: string;
  /** Una línea debajo del número: el importe, el detalle, el porqué. */
  caption?: string;
  /** Resalta la tarjeta cuando el número pide atención (estancados, retrasadas...). */
  tone?: "warning" | "error";
  /** Es un importe orientativo: lleva la etiqueta. */
  orientative?: boolean;
  /** Algo más debajo, como una barra de progreso. */
  footer?: React.ReactNode;
}

const KpiCard: React.FC<Props> = ({
  label,
  value,
  caption,
  tone,
  orientative,
  footer,
}) => {
  const theme = useTheme();
  const accent = tone ? theme.palette[tone].main : undefined;

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        border: `1px solid ${theme.palette.grey[200]}`,
        // La franja de la izquierda es el aviso; el texto de la tarjeta ya dice qué es,
        // así que el color nunca es el único canal.
        borderLeft: accent ? `4px solid ${accent}` : undefined,
        p: 2,
        minWidth: 0,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap={1}
      >
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        {orientative && <QualityChip />}
      </Stack>
      <Typography variant="h5" sx={{ fontWeight: 700, mt: 0.5 }}>
        {value}
      </Typography>
      {caption && (
        <Typography variant="caption" color="text.secondary" display="block">
          {caption}
        </Typography>
      )}
      {footer}
    </Paper>
  );
};

export default KpiCard;
